import React from "react";
import PropTypes from "prop-types";

function FuseFileInput(props) {
  const { id, accept, onChange, disabled  } = props;
  return (
    <div key={id+"div"}>
        <label htmlFor={"input"+id}><i className="fa fa-upload"></i></label>
        <input className="fuse-file-input" key={id+"input"} id={"input"+id}
         type="file" onChange={(e) => { onChange(e.target.files[0]); }} accept={accept} />
    </div>
  );
}


FuseFileInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string,
  disabled: PropTypes.bool,
};

export default FuseFileInput;
